import { render, staticRenderFns } from "./list-share.vue?vue&type=template&id=650ec71b&scoped=true&"
import script from "./list-share.vue?vue&type=script&lang=ts&"
export * from "./list-share.vue?vue&type=script&lang=ts&"
import style0 from "./list-share.vue?vue&type=style&index=0&id=650ec71b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650ec71b",
  null
  
)

export default component.exports